import { NgModule } from '@angular/core';
import { DragDropDirective } from './drag-drop.directive';

@NgModule({
    imports: [],
    exports: [DragDropDirective],
    declarations: [DragDropDirective],
    providers: []
})
export class DragDropModule {}
